import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface GoogleDriveImage {
  imageId: string;
  imageUrl: string;
  prompt: string;
  timestamp: string;
  generatedDate: string;
  thumbnailUrl?: string; // プロキシ経由のサムネイルURL
}

@Injectable({
  providedIn: 'root'
})
export class GoogleDriveImagesService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Google Sheetsから利用可能な画像一覧を取得
   */
  getAvailableImages(): Observable<{
    success: boolean;
    message: string;
    data: GoogleDriveImage[];
    count: number;
  }> {
    return this.http.get<{
      success: boolean;
      message: string;
      data: GoogleDriveImage[];
      count: number;
    }>(`${this.apiUrl}/google/available-images`);
  }

  /**
   * 画像URLからFileオブジェクトを作成（プロキシ経由）
   */
  async urlToFile(url: string, filename: string): Promise<File> {
    try {
      // バックエンドのプロキシエンドポイントを使用してCORS問題を回避
      const proxyUrl = `${this.apiUrl}/google/proxy-image?imageUrl=${encodeURIComponent(url)}`;
      const response = await fetch(proxyUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const blob = await response.blob();
      return new File([blob], filename, { type: blob.type });
    } catch (error) {
      console.error('Error converting URL to File:', error);
      throw new Error('画像のダウンロードに失敗しました');
    }
  }

  /**
   * 画像URLをプロキシURL経由で取得（サムネイル表示用）
   */
  getProxyImageUrl(originalUrl: string): string {
    return `${this.apiUrl}/google/proxy-image?imageUrl=${encodeURIComponent(originalUrl)}`;
  }
}